import React from "react";

export const LogoAa: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="48"
    viewBox="0 0 72 48"
    fill="none"
  >
    <path
      d="M70.0622 0H58.9006C58.3822 0 57.9061 0.275072 57.6522 0.729998L39.0214 34.1618V0.952171C39.0214 0.423187 38.5982 0 38.0692 0H26.9077C26.3893 0 25.9132 0.275072 25.6593 0.729998L0.119928 46.5717C-0.229202 47.2065 0.225725 47.9788 0.945143 47.9788H9.69454C10.2129 47.9788 10.6996 47.6932 10.9429 47.2383L15.4181 39.0284H28.4417V47.0373C28.4417 47.5662 28.8649 47.9894 29.3939 47.9894H41.6769C42.1953 47.9894 42.682 47.7038 42.9253 47.2488L47.4005 39.039H60.4241V47.0478C60.4241 47.5768 60.8473 48 61.3763 48H70.0622C70.5912 48 71.0144 47.5768 71.0144 47.0478V0.952171C71.0144 0.423187 70.5912 0 70.0622 0ZM28.4417 29.274H20.7291L27.9974 15.933C28.1138 15.7214 28.4417 15.806 28.4417 16.0494V29.274ZM60.4241 29.274H52.7115L59.9798 15.933C60.0961 15.7214 60.4241 15.806 60.4241 16.0494V29.274Z"
      fill="#00081C"
    />
  </svg>
);
